import PropTypes from 'prop-types';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import DateRangeReportCard from './DateRangeReportCard';
import {
    downloadMedicalEventsCsvReport,
    downloadMedicalEventsXlsxReport
} from '../../../../api/services/filesService';

function MedicalEventsCard({groupFilters}) {
    return (
        <DateRangeReportCard
            testId="medical-events-report"
            icon={<MonitorHeartOutlinedIcon sx={{fontSize: 48, mb: 2, color: '#155FA7'}}/>}
            title="Medical Events Report"
            groupFilters={groupFilters}
            downloadCsv={downloadMedicalEventsCsvReport}
            downloadXlsx={downloadMedicalEventsXlsxReport}
        />
    );
}

MedicalEventsCard.propTypes = {
    groupFilters: PropTypes.array
};

export default MedicalEventsCard;
